import styled from "@emotion/styled";
import React from "react";
import { BaseButtonStyle } from './BaseButtonStyle';

export const ButtonStyle = styled(BaseButtonStyle)({
  padding: "16px 48px",
});

const ButtonForm = ({
  title = "",
  disabled = false,
  onClick,
  fullWidth = true,
  onFocus,
  className = "",
  dataFlujo = "",
}) => {
  return (
    <ButtonStyle
      data-flujo={dataFlujo}
      className={className}
      onFocus={onFocus}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled}
      variant="contained"
      disableRipple
    >
      {title}
    </ButtonStyle>
  );
};

export default ButtonForm;
